import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {generate} from "../../../routing/routes";
import cx from "classnames";
import {NextButton} from "../../shared/components/Buttons";

export default function AdminForm({filters, type, status}) {
    const [reference, setRef] = useState("")
    const [draft, setDraft] = useState(false)
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(generate(draft ? 'book_edit' : 'customer_reservation', {reference}))
    }

    return <div className="mt-20 p-3 flex flex-col gap-2 bg-gray-100 w-full rounded-md text-gray-600 shadow-lg border">
            <div className="px-2 text-sm  text-gray-800">
            <p className="font-medium mb-2">Profil administrateur</p>
            <hr className="my-4" />
                Charger devis/résa client
            <div className="space-y-1 my-2">
                <input className={cx(
                    "block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 sm:text-sm",
                    "group-[.has-error]:input-error"
                )} type="text" value={reference} onChange={(e)=>setRef(e.target.value)} placeholder="REFERENCE devis/résa"/>
                <label><input checked={draft}
                              onChange={e=>{setDraft(e.target.checked)}}
                              className="h-4 w-4 rounded border-stone-400 text-orange-600 focus:ring-orange-500"
                              type="checkbox" /> édition brouillon</label>
            </div>
            <NextButton onClick={handleClick}>Charger</NextButton>
        </div>
    </div>
}